import { css } from 'emotion';
import { space } from '@joykit';
// import { DemoFontOption, DemoFontOptionKey } from '../../../types';
import { animationTransition } from '@joykit/variables';
import { getInterUIDynamicMetricCssObject } from 'fonts/Inter-UI/metrics';
import { DemoFontOptionKey } from '../../../types';
import { supportedFontFamily, textTransformFonts } from '@routes/event/guest/services/fonts/fontService';

export namespace styles {
  export const container = css({
    marginTop: -16
  });

  export const svgContainer = css({
    margin: space.stack.sm
  });

  export const optionContainer = css({
    textAlign: 'left',
    padding: '16px 8px',
    margin: '0 -8px',
    width: 'calc(100% + 16px)',
    transition: animationTransition('background-color'),
    ':hover': {
      backgroundColor: '#f8f8f8'
    }
  });

  export const testText = (font: DemoFontOptionKey) =>
    css({
      fontFamily: supportedFontFamily(font) === 'default' ? 'Inter UI' : supportedFontFamily(font),
      lineHeight: '21px',
      marginBottom: '8px',
      fontSize: '21px',
      textTransform: textTransformFonts.includes(font) ? 'uppercase' : 'none'
    });

  export const fontName = css({
    ...getInterUIDynamicMetricCssObject(13)
  });
}
